const FriendlyFractionNumeratorSpec = {
	content: "inline*",
	selectable:false,
	toDOM: () => ['span',{class:"friendlyFraction-numerator"},0],
	parseDOM: [{
		tag: 'span.friendlyFraction-numerator'}]
}

export default FriendlyFractionNumeratorSpec